import { DISCOUNT_CARD_MOCK_ROWS } from 'components/BlcCard/DiscountCard/mockDiscountCardRows';

export const DISCOUNTS_PAGE_SIZE = 25;

export const DISCOUNTS_DEFAULT_SORTING_OPTION = {
	value: 'requested_at_desc',
	text: 'Time since requested - newest first',
	sortBy: 'requested_at',
	direction: 'desc',
};

export const DISCOUNTS_SORTING_OPTIONS = [
	DISCOUNTS_DEFAULT_SORTING_OPTION,
	{
		value: 'requested_at_asc',
		text: 'Time since requested - oldest first',
		sortBy: 'requested_at',
		direction: 'asc',
	},
	{
		value: 'rep_name_asc',
		text: 'Rep name - A - Z',
		sortBy: 'rep_name',
		direction: 'asc',
	},
	{
		value: 'rep_name_desc',
		text: 'Rep name - Z - A',
		sortBy: 'rep_name',
		direction: 'desc',
	},
];

// TODO(goodwill-index): remove mock rows import when goodwill index endpoint is wired.
const totalCount = DISCOUNT_CARD_MOCK_ROWS.length;

export const initialState = {
	// TODO(goodwill-index): derive metadata from index response instead of mock row length.
	metadata: {
		page: 1,
		per_page: DISCOUNTS_PAGE_SIZE,
		total_count: totalCount,
		page_count: Math.max(Math.ceil(totalCount / DISCOUNTS_PAGE_SIZE), 1),
	},
	loading: false,
	currentRequestId: null,
	success: true,
	errors: {
		approvalRequestErrorMessage: '',
	},
	statuses: [],
	page: 1,
	sorting: DISCOUNTS_DEFAULT_SORTING_OPTION.value,
};
